import { GENERATED_SLUG_ID_VENUES_INVENTORY_SYSTEM_TYPES } from '../../../constants'
import type { VenueDTO } from '../../../types'

export function isGeneratedSlugIdVenue(
  venue: Pick<VenueDTO, 'id' | 'venueSlug' | 'inventorySystemType'>
): boolean {
  return (
    venue.id !== venue.venueSlug &&
    GENERATED_SLUG_ID_VENUES_INVENTORY_SYSTEM_TYPES.includes(
      venue.inventorySystemType
    )
  )
}
